<div [ngStyle]="style" class="p-[10px]">
  <div class="mb-[10px] text-body-copy relative">
    <i class="fas fa-search absolute mr-[6px] t-[6px]"></i>
    <input style="width:100%;" type="text" pInputText [(ngModel)]="keyWord"
      class="search block pl-[20px] no-border border-b " placeholder="Search">
  </div>
  <ng-container *ngIf="customFilter!=null">
    <ng-container *ngTemplateOutlet="customFilter"></ng-container>
  </ng-container>
  <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="a-ul thin-scroller" [ngStyle]="listStyle">
    <div *cdkVirtualFor="let option of optionsDisplay;
        let index = index;
        let count = count;
        let first = first;
        let last = last;
        let even = even;
        let odd = odd;" class="a-li p-[5px]  text-charcol-500" [ngClass]="{highlight:option===value}"
      (click)="onClick(option)">
      <ng-container
        *ngTemplateOutlet="itemTemplate!=null?itemTemplate:defaultItem; context:{$implicit:option,index:index,count:count,first:first,last:last,even:even,odd:odd}">
      </ng-container>
    </div>
  </cdk-virtual-scroll-viewport>
</div>

<ng-template #defaultItem let-option>
  <i [ngClass]="option===value?'fas fa-check text-center text-[8px] w-[12px] h-[12px] leading-[12px] bg-orange-500 text-white':option.icon"
    class="mr-[6px]" *ngIf="option.icon"></i>
  <span>{{option.label}}</span>
</ng-template>